module.exports = __webpack_public_path__ + "assets/7021b14b0b43dd983a4206723812e6a8.png";